import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UmssIconComponent } from '../icon/icon.component';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

@Component({
  selector: 'umss-rate-table',
  standalone: true,
  imports: [CurrencyPipe, UmssIconComponent, UmssTooltipDirective],
  templateUrl: './rate-table.component.html',
  styleUrl: './rate-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssRateTableComponent {
  baseRate = input.required<number>();
  differentialRate = input.required<number>();
  urgentRate = input<number | undefined>(undefined);
  isBaseRateScheduled = input<boolean | undefined>();
  isDifferentialScheduled = input<boolean | undefined>();
  baseRateDateRange = input<string | undefined>(undefined);
  differentialDateRange = input<string | undefined>(undefined);

  get baseTotal(): number {
    return Number(this.baseRate()) + Number(this.differentialRate());
  }

  get urgentTotal(): number {
    return Number(this.urgentRate() ?? 0) + Number(this.differentialRate());
  }
}
